// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5ffdeebd","99":"ddcc099d","199":"3eff042a","270":"ca056beb","544":"eadf53e6","557":"02a973ad","872":"3f0be6f2"}[chunkId] + ".chunk.js";
};